<template>
  <section class="section white">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
          <div class="box-text margin-top-60">
            <h1 class="lato size-34 margin-bottom-40 txt-black">Contacta con andalepide</h1>
          </div>	
          <div class="row contact-info">
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <div class="box-text">
                <h1 class="lato txt-green size-24 regular">Cliente</h1>
                <p class="size-16 margin-bottom-20">¿Deseás contratar nuestros servicios para los almuerzos de tus empleados?</p>
              </div>
              <div class="box-text">
                <span class="line2"></span>
                <p class="size-18 no-margin">info@andalepide.com</p>
                <p class="size-18">+54 351 250 3773</p>
                <p class="size-18">+54 351 771 8029</p>
              </div>	
            </div>
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <div class="box-text">
                <h1 class="lato txt-green size-24 regular">Proveedor</h1>
                <p class="size-16 margin-bottom-20">¿Querés vender tus comidas a través de Andalepide?</p>
              </div>
              <div class="box-text">
                <span class="line2"></span>
                <p class="size-18 no-margin">info@andalepide.com</p>
                <p class="size-18">+54 351 250 3773</p>
                <p class="size-18">+54 351 771 8029</p>
              </div>	
            </div>
          </div>
          <div class="clear-sm"></div>
          <form class="form">
            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <label>Nombre</label>
                  <input type="text" v-model="formData.nombre" class="form-control"/>
                  <span class="label label-danger" v-if="!$v.formData.nombre.required && mostrarErrores">Campo requerido</span>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <label>Apellido</label>
                  <input type="text" v-model="formData.apellido" class="form-control"/>
                  <span class="label label-danger" v-if="!$v.formData.apellido.required && mostrarErrores">Campo requerido</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <label>Nombre de tu empresa</label>
                  <input type="text" v-model="formData.nombreEmpresa" class="form-control"/>
                  <span class="label label-danger" v-if="!$v.formData.nombreEmpresa.required && mostrarErrores">Campo requerido</span>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <label>Barrio o Zona</label>
                  <input type="text" v-model="formData.barrio" class="form-control"/>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <label>E-Mail</label>
                  <input type="mail"  v-model="formData.email" class="form-control"/>
                  <span class="label label-danger" v-if="!$v.formData.email.email && mostrarErrores">Campo requerido</span>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <label>Teléfono</label>
                  <input type="text"  v-model="formData.telefono" class="form-control"/>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 ">
                <div class="form-group">
                  <label for="">Mensaje</label>
                  <textarea rows="7"  v-model="formData.mensaje" class="form-control"></textarea>
                  <span class="label label-danger" v-if="!$v.formData.mensaje.required && mostrarErrores">Campo requerido</span>
                </div>
              </div>
            </div>
            <div class="row text-center center-block">
              <vue-recaptcha 
                sitekey="6LfZAikUAAAAAOU_SNuSQG_-dF2mOiHV4XHqrpaF"
                @verify="onVerify"
              >
              </vue-recaptcha>
            </div>
            <div class="form-action text-center">
              <button type="button" class="btn btn-fill btn-lg size-16" @click.prevent="clickEnviar">ENVIAR</button>
            </div>
          </form>
      
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import {email, required} from 'vuelidate/lib/validators'
  import VueRecaptcha from 'vue-recaptcha'
  export default {
    components: {
      'vue-recaptcha': VueRecaptcha
    },
    data () {
      return {
        mostrarErrores: false,
        formData: {
          nombre: '',
          apellido: '',
          nombreEmpresa: '',
          barrio: '',
          email: '',
          telefono: '',
          mensaje: '',
          respuestaCaptcha: null
        }
      }
    },
    methods: {
      clickEnviar () {
        const me = this
        me.mostrarErrores = false
        if (me.$v.formData.$invalid) {
          me.mostrarErrores = true
          return false
        }
        me.$http.post('/api/public/contacto', me.formData)
        .then(({body}) => {
          me.$emit('mostrar-notificacion', 'El mensaje se ha enviado correctamente', 'success')
          me.limpiar()
        }, (err) => {
          console.error(err)
        })
      },
      limpiar () {
        const me = this
        me.formData = {
          nombre: '',
          apellido: '',
          telefono: '',
          nombreEmpresa: '',
          email: '',
          mensaje: '',
          respuestaCaptcha: null,
          barrio: ''
        }
      },
      onVerify (response) {
        const me = this
        me.formData.respuestaCaptcha = response
      }
    },
    validations: {
      formData: {
        nombre: {
          required
        },
        apellido: {
          required
        },
        nombreEmpresa: {
          required
        },
        email: {
          required,
          email
        },
        mensaje: {
          required
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Contacto.vue?495d8b60